import { useState } from "react";

export const useModal = (
  action?: (params?: any) => void,
  removeSearchParamsHandler?: () => void
) => {
  const [modal, setModal] = useState<boolean>(false);

  const openModalHandler = () => {
    setModal(true);
  };

  const closeModalHandler = () => {
    if (removeSearchParamsHandler) {
      removeSearchParamsHandler();
    }
    setModal(false);
  };

  const submitModalHandler = () => {
    if (action) {
      action();
    }
    closeModalHandler();
  };

  return {
    modal,
    openModalHandler,
    closeModalHandler,
    submitModalHandler,
  };
};
